//axios api
import api from "@/lib/Api";

export const getImagesKeyById = async (giveaway_invoice_id) => {
  try {
    const queryRoute = `/giveaway/getImagesKeyById`;

    const reqBody = {
      invoiceId: giveaway_invoice_id,
    };

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getGiveawayListByCustId = async (
  custId,
  startDate,
  endDate,
  brand = null,
  searchText = null,
) => {
  try {
    const queryRoute = `/giveaway/getGiveawayListByCustId/${custId}`;

    const reqBody = {
      startDate: startDate ? startDate : null,
      endDate: endDate ? endDate : null,
      brand,
      searchText,
    };

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const importGiveaway = async (datetime, data) => {
  try {
    const queryRoute = `/giveaway/importGiveaway`;

    const reqBody = {
      datetime: datetime,
      data: data,
    };

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const deleteGiveawayRecord = async (datetime) => {
  try {
    const queryRoute = `/giveaway/deleteGiveawayRecord`;

    const reqBody = {
      datetime: datetime,
    };

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getProducts = async () => {
  try {
    const queryRoute = `/giveaway/getProducts`;

    const fetchRes = api.axios.get(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getPromotors = async () => {
  try {
    const queryRoute = `/giveaway/getPromotors`;

    const fetchRes = api.axios.get(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
export const exportExcel = async (
  promoter_ids,
  startDate,
  endDate,
  product_ids,
  giveaway_ids,
  phone,
) => {
  try {
    const queryRoute = `/giveaway/exportExcel`;
    const reqBody = {
      promoter_ids,
      startDate,
      endDate,
      product_ids,
      giveaway_ids,
      phone,
    };
    const fetchRes = api.axios.post(queryRoute, reqBody, {
      responseType: "blob",
    });
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
export const getGiveawayInvoice = async (
  promoter_ids,
  startDate,
  endDate,
  product_ids,
  giveaway_ids,
  phone,
) => {
  try {
    const queryRoute = `/giveaway?startDate=${startDate}&endDate=${endDate}&promoter_ids=${promoter_ids}&product_ids=${product_ids}&giveaway_ids=${giveaway_ids}&phone=${phone}`;

    const fetchRes = api.axios.get(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getGiveawayInvoiceById = async (id) => {
  try {
    const queryRoute = `/giveaway/${id}`;

    const fetchRes = api.axios.get(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const checkGiveawayInvoice = async (id) => {
  try {
    const queryRoute = `/giveaway/${id}/check`;

    const fetchRes = api.axios.post(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
export const getCustomerDailyInvoice = async (
  selectedPromotorId,
  startDate,
  endDate,
  product,
) => {
  try {
    const queryRoute = `/giveaway/getCustomerDailyInvoice`;

    const reqBody = {
      type: "website",
      selectedPromotorId,
      startDate: startDate ? startDate : null,
      endDate: endDate ? endDate : null,
      product: product ? product : null,
    };

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

//add a new api call function to retrieve giveaway master item
export const getGiveawayMasterItems = async () => {
  try {
    const queryRoute = `/giveaway/getGiveawayMasterItems`;

    const fetchRes = api.axios.post(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

//create a fetch to call API "/customer/getGiveawayList/"
export const getGiveawayList = async (criteria, startDate, endDate) => {
  try {
    const queryRoute = `/giveaway/getGiveawayList/`;

    const reqBody = {
      criteria: criteria ? criteria : null,
      startDate: startDate ? startDate : null,
      endDate: endDate ? endDate : null,
    };

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

//create a fetch to call API "/giveaway/getGiveawayList/"
export const getGiveawayManage = async () => {
  try {
    const queryRoute = `/giveaway/getGiveawayManage`;

    const fetchRes = api.axios.post(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

//create a fetch to call API "/giveaway/getGiveawayList/"
export const updateGiveawayManage = async (giveAwayData) => {
  try {
    const queryRoute = `/giveaway/updateGiveawayManage`;

    const reqBody = { ...giveAwayData };

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

//create a call API "/giveaway/createGiveawayManage/"
export const createGiveawayManage = async (giveAwayData) => {
  try {
    const queryRoute = `/giveaway/createGiveawayManage`;

    const reqBody = { ...giveAwayData };

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

//create a call API "/giveaway/activeGiveawayManage/"
export const activeGiveawayManage = async (date) => {
  try {
    const queryRoute = `/giveaway/activeGiveawayManage/${date}`;

    const fetchRes = api.axios.post(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

//create a call API "/giveaway/updatedactiveGiveawayManage /"
export const updatedactiveGiveawayManage = async (updatedRows) => {
  try {
    const queryRoute = `/giveaway/updateActiveGiveawayManage`;

    const reqBody = {
      updatedRows,
    };

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

//create a call API "/giveaway/getMonthlyGiveawayMaster/"
export const getMonthlyGiveawayMaster = async (datetime, data) => {
  try {
    const queryRoute = `/giveaway/getMonthlyGiveawayMaster`;

    const fetchRes = api.axios.post(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

//create a call API "/giveaway/importMonthlyActiveGiveaway/"
export const importMonthlyActiveGiveaway = async (datetime, data) => {
  try {
    const queryRoute = `/giveaway/importMonthlyActiveGiveaway`;

    const reqBody = {
      datetime: datetime,
      data: data,
    };

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

//create a call API "/giveaway/getPrevMonthlyActiveGiveaway/"
export const getPrevMonthlyActiveGiveaway = async (dateTime) => {
  try {
    const queryRoute = `/giveaway/getPrevMonthlyActiveGiveaway`;

    const reqBody = {
      dateTime: dateTime,
    };

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

//create a call API "/giveaway/importMonthlyActiveGiveawayByMonth/"
export const importMonthlyActiveGiveawayByMonth = async (
  listDateTime,
  copyListDateTime,
) => {
  try {
    const queryRoute = `/giveaway/importMonthlyActiveGiveawayByMonth`;

    const reqBody = {
      listDateTime,
      copyListDateTime,
    };

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
